module.exports = __webpack_public_path__ + "static/media/ppt.37dc4b4a.svg";